import { FLAG_META, isKnownFlag, type FlagId } from '../lib/flags';
import { Tooltip } from './ui/Tooltip';

/**
 * PROD1.7.8 N2 — Badge pour un flag LLM (cas complexe).
 *
 * Affiche le label court + tooltip explicatif au hover. Si le flag est
 * inconnu (LLM a inventé un flag, ou désynchro front/back), affiche un
 * badge gris avec l'identifiant brut pour debug.
 */
interface FlagBadgeProps {
  flag: string;
  /** Compact : padding réduit pour les listes denses. */
  compact?: boolean;
}

export function FlagBadge({ flag, compact = false }: FlagBadgeProps) {
  const padding = compact ? 'px-1.5 py-0' : 'px-2 py-0.5';

  if (!isKnownFlag(flag)) {
    return (
      <span
        className={`${padding} rounded text-xs bg-gray-100 text-gray-700 border border-gray-300`}
        title={`Flag inconnu (front désynchronisé ?) : ${flag}`}
      >
        ⚠ {flag}
      </span>
    );
  }

  const meta = FLAG_META[flag as FlagId];

  return (
    <Tooltip content={meta.description}>
      <span
        className={`${padding} rounded text-xs border ${meta.className} cursor-help`}
      >
        {meta.label}
      </span>
    </Tooltip>
  );
}

/**
 * Liste de badges flags avec séparation visuelle. Rien si flags vide.
 */
interface FlagBadgeListProps {
  flags: string[];
  compact?: boolean;
}

export function FlagBadgeList({ flags, compact = false }: FlagBadgeListProps) {
  if (!flags || flags.length === 0) return null;
  return (
    <span className="inline-flex flex-wrap gap-1">
      {flags.map((f) => (
        <FlagBadge key={f} flag={f} compact={compact} />
      ))}
    </span>
  );
}
